import { createSelector } from '@reduxjs/toolkit';
import selfSelector from './self';

const loadingSelector = createSelector(selfSelector, (domainsReport) => domainsReport.loading);

export default loadingSelector;
